module.exports = __webpack_public_path__ + "russierenouvelables/img/1-5.6b0f18ed.webp";